import { IconPencil } from '@tabler/icons-react'
import React from 'react'

const EditButton = ({disabled = false, onlyIcon = false, ...prop}) => {
	return (
		<button type="submit" className={`btn btn-outline-primary ${disabled ? 'cursor-not-allowed' : ''}  ${onlyIcon ? 'btn-only-icon' : ''} `} title='Промени' disabled={disabled} {...prop}>
			<IconPencil size={18} className={`${ onlyIcon ? '' : 'me-2' } svg-icon btn-icon`} />
			{ onlyIcon ? '' : 'Промени' }
		</button>
	)
}

export default EditButton